export const OPEN_OVERLAY = 'overlay/OPEN_OVERLAY';
export const CLOSE_OVERLAY = 'overlay/CLOSE_OVERLAY';
export const TOGGLE_OVERLAY = 'overlay/TOGGLE_OVERLAY';
